import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import lang from '@data/lang.json'
import utils from '@/utils/utils'

const Checkout = {
  props: [
    'getEndpoint',
    'editCartEndpoint',
    'editDeliveryEndpoint',
    'editPostcodeEndpoint',
    'editRotEndpoint'
  ],
  // Data
  data () {
    return {
      activeStep: 1,
      lang: lang,
      postcode: {
        changeStoreActive: false,
        inputValue: '',
        status: 'idle'
      },
    }
  },
  // Computed
  computed: {
    ...mapGetters('cart', {
      totalPrice: 'totalPrice',
      products: 'cartProducts',
    }),
    ...mapGetters('checkout', {
      store: 'store'
    }),
    ...mapState({
      quantity: state => state.cart.totalItems,
      status: state => state.cart.status,
      sveaLayout: state => state.checkout.svea.Layout,
      sveaSnippet: state => {
        window._sveaCheckoutScriptsEvaluated = false
        return state.checkout.svea.Snippet
      },
      deliveryData: state => state.checkout.delivery,
      checkoutStatus: state => state.checkout.status
    }),
    activeDeliveryRadio: {
      get () {
        return this.$store.state.checkout.activeDelivery
      },
      set (value) {
        this.$store.commit('checkout/setActiveDelivery', value)
      }
    },
    rotCheckbox: {
      get() {
        return this.$store.state.checkout.rotChecked
      },
      set (value) {
        this.$store.commit('checkout/setRotChecked', value)
      }
    }
  },
  // Methods
  methods: {
    decrementProduct (id, quantity) {
      this.activeStep = 0

      const productId = id
      let newQuantity = quantity -1 >= 0 ? quantity -1 : 0
      newQuantity = parseInt(newQuantity)

      this.$store.dispatch(
        'checkout/setCheckout', {
          api: this.editCartEndpoint,
          params: {
            ItemId: productId,
            Quantity: newQuantity
          }
        }
      )
    },
    onDeliveryChange () {
      this.$store.dispatch(
        'checkout/setCheckout', {
          api: this.editDeliveryEndpoint,
          params: {
            Type: this.activeDeliveryRadio
          }
        }
      )
    },
    onPostcodeChange () {
      this.postcode.status = 'idle'
    },
    onRotChange () {
      axios.post(this.editRotEndpoint, {
        UseRot: this.rotCheckbox
      })
    },
    postcodeSubmit () {
      this.activeStep = 0

      if (this.postcode.inputValue.length !== 5) {
        this.postcode.status = 'error'
      } else {
        this.postcode.changeStoreActive = false

        this.$store.dispatch(
          'checkout/setCheckout', {
            api: this.editPostcodeEndpoint,
            params: {
              ZipCode: this.postcode.inputValue
            }
          }
        )
      }
    },
    productPath: function(product) {
      if(product.url && product.url.length > 0) {
        return product.url
      }
      else if (!product.urlPath) {
        return ''
      } else {
        return utils.checkForSlashAtEnd(window.location.pathname) + utils.checkForSlashAtEnd(product.urlPath)
      }
    },
    toggleStore () {
      this.postcode.changeStoreActive = !this.postcode.changeStoreActive
    },
  },
  // Life cycle
  mounted () {
    this.$store.dispatch(
      'checkout/getCheckout', {
        api: this.getEndpoint,
        params: null
      }
    )
  },
  updated () {
    //console.log("Updated method", window._sveaCheckoutScriptsEvaluated)
    if (!!window._sveaCheckoutScriptsEvaluated || !!window._sveaCheckoutScriptsLock)
        return
    //
    let checkoutContainer = document.getElementById('svea-widget')
    if(checkoutContainer == null)
      return
    //console.log("Update Svea scripts", window._sveaCheckoutScriptsEvaluated)
    window._sveaCheckoutScriptsEvaluated = true
    window._sveaCheckoutScriptsLock = true
    let scripts = [];
    let scriptsTags = checkoutContainer.getElementsByTagName('script')
    for(let scriptTag of scriptsTags) {
      scripts.push({
        type: scriptTag.type,
        src: scriptTag.src,
        text: scriptTag.text,
      });
    }
    //console.log("Script tags",scripts, scriptsTags);
    // This is necessary otherwise the scripts tags are not going to be evaluated
    for (let i = 0; i < scripts.length; i++) {
      let newScriptTag = document.createElement('script')
      newScriptTag.type = scripts[i].type
      if(scripts[i].src.length > 0)
        newScriptTag.src = scripts[i].src
      if(scripts[i].text.length > 0)
        newScriptTag.text = scripts[i].text

      let parentNode = scriptsTags[i].parentNode
        parentNode.removeChild(scriptsTags[i])
        parentNode.appendChild(newScriptTag)

      //console.log("Script removed", scriptsTags[i])
      //console.log("Script append", newScriptTag)
    }
    window._sveaCheckoutScriptsLock = false
  }
}

export default Checkout
